import { Component, Input } from '@angular/core';
import { RRProgressbarModel } from '../../models/progressbar.model';

@Component({
  selector: 'rr-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.scss'],
})
export class ProgressbarComponent {
  @Input() model: RRProgressbarModel;

  constructor() {}

  getPercentage(): number {
    return this.model == null ||
      this.model.value == null ||
      this.model.max == null ||
      Number.isNaN(this.model.value) ||
      Number.isNaN(this.model.max)
      ? 0
      : Math.trunc((this.model.value / this.model.max) * 100);
  }
}
